var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.icon},[_c('img',{attrs:{"src":_setup.iconSrc,"alt":"Arch Tech Solutions Logo"}}),(!_setup.iconSrc)?_c('span',[_vm._v("Arch Tech Solutions")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }